import { RoutePaths } from '../../config/routes';
import ReassuranceItem from '../../components/Reassurance/Item';
import { Handshake, Sparkle } from '../../components/CustomIcon';
import Paragraph from '../../components/Typography/Paragraph';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import List from '../../components/List/List';
import Heading from '../../components/Typography/Heading';
export var useReassurance = function () {
    var _a;
    var pathname = useLocation().pathname;
    var _b = useState(), reassurances = _b[0], setReassurances = _b[1];
    useEffect(function () {
        setReassurances(getReassurances(pathname));
    }, [pathname]);
    var allReassurances = (_a = {},
        _a[RoutePaths.SIGN_UP_PROFESSIONAL] = [
            <ReassuranceItem icon={Handshake}>
        <Heading level={6}>Pourquoi ajouter ma photo&nbsp;?</Heading>
        <Paragraph size="sm" className="mt-2">
          Votre photo permet aux autres membres de vous reconnaître et de mieux mémoriser votre
          profil. Alors, présentez-vous sous votre meilleur jour !
        </Paragraph>
      </ReassuranceItem>,
        ],
        _a[RoutePaths.SIGN_UP_PROFILE] = [
            <ReassuranceItem icon={Handshake}>
        <Heading level={6}>À quoi sert le titre de mon profil&nbsp;?</Heading>
        <Paragraph size="sm" className="mt-2">
          Visible en haut de votre profil, ce titre permet de comprendre en un coup d’oeil qui vous
          êtes et votre expertise principale.
        </Paragraph>
      </ReassuranceItem>,
            <ReassuranceItem icon={Sparkle}>
        <Heading level={6}>Quelques exemples&nbsp;:</Heading>
        <List className="mt-2">
          <li>Manager d’artistes | Jazz, Soul, Funk</li>
          <li>Compositrice de musique classique</li>
          <li>Technicienne & Mixeuse son</li>
        </List>
      </ReassuranceItem>,
        ],
        _a[RoutePaths.SIGN_UP_CONTACT] = [
            <ReassuranceItem icon={Handshake}>
        <Heading level={6}>Qui pourra me contacter&nbsp;?</Heading>
        <Paragraph size="sm" className="mt-2">
          Seules les personnes disposant d’un compte sur Majeur·e·s peuvent accéder à vos
          coordonnées. Vos relations sont sécurisées pour des échanges plus constructifs !
        </Paragraph>
      </ReassuranceItem>,
        ],
        _a[RoutePaths.SIGN_UP_SOCIAL] = [
            <ReassuranceItem icon={Handshake}>
        <Heading level={6}>Qui pourra me contacter&nbsp;?</Heading>
        <Paragraph size="sm" className="mt-2">
          Seules les personnes disposant d’un compte sur Majeur·e·s peuvent accéder à vos
          coordonnées. Vos relations sont sécurisées pour des échanges plus constructifs !
        </Paragraph>
      </ReassuranceItem>,
            <ReassuranceItem icon={Sparkle}>
        <Heading level={6}>Et si je ne veux pas répondre&nbsp;?</Heading>
        <Paragraph size="sm" className="mt-2">
          Cliquez tout simplement sur “Passer”. Vous pourrez revenir sur cette section si besoin,
          une fois votre profil enregistré.
        </Paragraph>
      </ReassuranceItem>,
        ],
        _a[RoutePaths.SIGN_UP_EXPERIENCE] = [
            <ReassuranceItem icon={Handshake}>
        <Heading level={6}>Quelle(s) expérience(s) indiquer&nbsp;?</Heading>
        <Paragraph size="sm" className="mt-2">
          En général, les membres Majeur·e·s indiquent des expériences présentes ou passées qui
          représentent leur parcours professionnel.
        </Paragraph>
      </ReassuranceItem>,
            <ReassuranceItem icon={Handshake}>
        <Heading level={6}>Quelques exemples&nbsp;:</Heading>
        <List className="mt-2">
          <li>Manager - Spotify</li>
          <li>Chef·fe d'orchestre</li>
          <li>Étudiant·e - Conservatoire de Paris</li>
        </List>
      </ReassuranceItem>,
            <ReassuranceItem icon={Sparkle}>
        <Heading level={6}>Et si je ne veux pas répondre&nbsp;?</Heading>
        <Paragraph size="sm" className="mt-2">
          Cliquez tout simplement sur “Passer”. Vous pourrez revenir sur cette section si besoin,
          une fois votre profil enregistré.
        </Paragraph>
      </ReassuranceItem>,
        ],
        _a[RoutePaths.SIGN_UP_IDENTITY] = [
            <ReassuranceItem icon={Handshake}>
        <Heading level={6}>Pourquoi indiquer mon identité&nbsp;?</Heading>
        <Paragraph size="sm" className="mt-2">
          Pour aider les équipes Majeur·e·s à s’assurer de la conformité des profils référencés sur
          l’annuaire (femmes cisgenres, personnes trans et non-binaires).
        </Paragraph>
      </ReassuranceItem>,
            <ReassuranceItem icon={Handshake}>
        <Heading level={6}>Pourquoi préciser mon pronom ?</Heading>
        <Paragraph size="sm" className="mt-2">
          Cette précision permet aux personnes qui souhaitent vous contacter de le faire de la bonne
          manière.
        </Paragraph>
      </ReassuranceItem>,
            <ReassuranceItem icon={Sparkle}>
        <Heading level={6}>Et si je ne veux pas répondre&nbsp;?</Heading>
        <Paragraph size="sm" className="mt-2">
          Cliquez tout simplement sur “Passer”. Vous pourrez revenir sur cette section si besoin,
          une fois votre profil enregistré.
        </Paragraph>
      </ReassuranceItem>,
        ],
        _a);
    var getReassurances = function (path) {
        return allReassurances[path];
    };
    return { reassurances: reassurances };
};
